import { takeLatest, call, put, StrictEffect, cancel, delay, select, getContext } from 'redux-saga/effects';
import tools, { auditCodeSnippet, auditCodeSnippetError, auditCodeSnippetSuccess, auditSinglePage, auditSinglePageError, auditSinglePageSuccess, checkImageDescription, checkImageDescriptionError, checkImageDescriptionSuccess, codeSnippetCheckerError, codeSnippetCheckerErrorH, codeSnippetCheckerH, codeSnippetCheckerI, codeSnippetCheckerSuccess, codeSnippetCheckerSuccessH, generateDescription, generateDescriptionError, generateDescriptionSuccess, getWebsiteContext, getWebsiteContextError, getWebsiteContextSuccess, languageLevelChecker, languageLevelCheckerError, languageLevelCheckerSuccess, singlePageAuditErrorH, singlePageAuditH, singlePageAuditSuccessH, singlePagesDataError, singlePagesDataI, singlePagesDataSuccess, upalodImage, upalodImageError, upalodImageSuccess } from './index';
import { PayloadAction } from '@reduxjs/toolkit';
import { apiInstance } from 'src/services/interceptor';
import { SagaIterator } from 'redux-saga';
import { Exception } from 'sass';
import { log } from 'console';
import axios from 'axios'; // You need axios or another HTTP client to perform the upload

function* UploadImageSaga({ payload: { file } }:any): SagaIterator {
    try {
        const response:any = yield call(apiInstance.get, `reporttool/tools/image-gd/generate-presigned-url?fileName=${file?.name}`);
        const presignedUrl = response?.data?.presignedUrl;
        const key = response?.data?.key;

        if (!presignedUrl || !key) {
            throw new Error("Problem in generating presigned URL");
        }
        
        // Upload the file to the presigned URL
        const uploadResponse = yield call(axios.put, presignedUrl, file, {
            headers: {
                'Content-Type': file.type // Set the appropriate content type for the file being uploaded
            }
        });        
        // Check for successful response from the server, usually a 200 OK
        if (uploadResponse.status !== 200) {
            throw new Error("Failed to upload file");
        }

        // Dispatch success action with the key of the uploaded file
        yield put(upalodImageSuccess(key));

    } catch (error:any) {
        // Dispatch error action with the error message
        yield put(upalodImageError(error?.response?.data?.details ?? error.toString()));

    }
}



function* generateDescriptionSaga({ payload: { imageKey,  autorizeContext, webPageUrl } }:any): SagaIterator {
    try {
        let response:any ;
        if(autorizeContext){
            if(!webPageUrl){
                throw new Error("please enter a webPage Url  ");
            }
            response = yield call(apiInstance.post, `reporttool/tools/image-gd/generate-description-based-on-webpage`,{
                url:webPageUrl, 
                imageKey
            });
        }else{
            response = yield call(apiInstance.get, `reporttool/tools/image-gd/generate-description?imageKey=${imageKey}`);
        }

        const description = autorizeContext ? response?.data?.result  : response?.data?.description;

        if (!description) {
            throw new Error("Problem in generating description");
        }

        yield put(generateDescriptionSuccess(description));

    } catch (error:any) {        
        // Dispatch error action with the error message
        yield put(generateDescriptionError(error?.response?.data?.details ?? error.toString()));
    }
}



function* checkImageDescriptionSaga({ payload: { imageKey, givenDescription } }:any): SagaIterator {
    try {
        const response:any = yield call(apiInstance.post, `reporttool/tools/image-dc/check-description`,{
             imageKey,
             givenDescription
        });

        // const score = response?.data?.result?.score ;
        const explanation = response?.data?.result?.explanation;
    
        if (  !explanation ) {
            throw new Error("Problem in processing image");
        }

        yield put(checkImageDescriptionSuccess(explanation));

    } catch (error:any) {
        // Dispatch error action with the error message
        // yield put(checkImageDescriptionError(error.toString()));
        yield put(checkImageDescriptionError(error?.response?.data?.error ?? error.toString()));

    }
}


function* getWebsiteContextSaga({ payload: { url } }:any): SagaIterator {
    try {
        const response:any = yield call(apiInstance.post, `reporttool/tools/webpage/context`,{
            url,
        });

        // const score = response?.data?.result?.score ;
        const context = response?.data?.context;
    
        if (  !context ) {
            throw new Error("Problem in processing the webpage");
        }

        yield put(getWebsiteContextSuccess(context));

    } catch (error:any) {
        // Dispatch error action with the error message
        // yield put(checkImageDescriptionError(error.toString()));
        yield put(getWebsiteContextError(error?.response?.data?.details ?? error.toString()));

    }
}


function* auditSinglePageSaga({ payload: { pageUrl, auditStandard } }:any): SagaIterator {
    try {
        
        if(!pageUrl){
            throw new Error("Please enter a webpage");
        }
        const response:any = yield call(apiInstance.post, `reporttool/tools/audit/audit-single-page`,{
             pageUrl,
             auditStandard
        });
        const pageId = response?.data?.pageId;
    
        if (  !pageId ) {
            throw new Error("Problem  the audit not started");
        }


        while (true) {
            try {

                    const check_existance = yield call(apiInstance.get, `reporttool/tools/audit/single-page-audit/${pageId}`);                     
                    if(check_existance?.data?.message == 'NoSuchKey'){

                            yield delay(3000);
                            continue;
                    }

                    if(check_existance?.status != 200){
                        throw new Error("check auditing has faild");
                    }

                                     
                    if (check_existance?.data?.mapData ) {                        
                        yield put(auditSinglePageSuccess(check_existance?.data?.mapData));
                        yield cancel();
                    } 

                } catch (error :any) {
                    if(error.response?.data?.status != 404){
                        const errorMessage = error.response?.data?.message ?? 'error';
                        yield put(auditSinglePageError(errorMessage));
                    }
                }
            }
        

        // yield put(auditSinglePageSuccess(context));

    } catch (error:any) {
        // Dispatch error action with the error message
        // yield put(checkImageDescriptionError(error.toString()));
        yield put(auditSinglePageError(error?.response?.data?.details ?? error.toString()));

    }
}



function* auditCodeSnippetSaga({ payload: { htmlSnippet,auditStandard, domainName } }:any): SagaIterator {
    try {
        if(!htmlSnippet){
            throw new Error("Please enter a html Snippet");
        }
        const response:any = yield call(apiInstance.post, `reporttool/tools/audit/audit-html-snippet`,{
             htmlSnippet,
             auditStandard,
             domainName
        });

        const snippetId = response?.data?.snippetId;
    
        if (  !snippetId ) {
            throw new Error("Problem  the audit not started");
        }


        while (true) {
            try {

                    const check_existance = yield call(apiInstance.get, `reporttool/tools/audit/html-snippet-audit/${snippetId}`); 
                            
                    if(check_existance?.data?.message == 'NoSuchKey'){

                            yield delay(3000);
                            continue;
                    }

                    if(check_existance?.status != 200){
                        throw new Error("check auditing has faild");
                    }

                                     
                    if (check_existance?.data?.mapData) {
                        yield put(auditCodeSnippetSuccess(check_existance?.data?.mapData));
                        yield cancel();
                    } 

                } catch (error :any) {
                    if(error.response?.data?.status != 404){
                        const errorMessage = error.response?.data?.message ?? 'error';
                        yield put(auditCodeSnippetError(errorMessage));
                    }
                }
            }
        


    } catch (error:any) {
        // Dispatch error action with the error message
        yield put(auditCodeSnippetError(error?.response?.data?.details ?? error.toString()));

    }
}


function* languageLevelCheckerSaga({ payload: { textInput } }:any): SagaIterator {
    try {
        if(!textInput){
            throw new Error("Please enter a Text");
        }
        const response:any = yield call(apiInstance.post, `reporttool/tools/languagecheck/language-checker`,{
            textInput
        });
        
        const languageCheck = response?.data?.languageCheck;
    
        if (  !languageCheck ) {
            throw new Error("Problem  the audit not started");
        }
                                     
        yield put(languageLevelCheckerSuccess(languageCheck));

    } catch (error:any) {
        // Dispatch error action with the error message
        yield put(languageLevelCheckerError(error?.response?.data ?? error.toString()));

    }
}

function* singlePagesDataSaga({ payload} :any): SagaIterator {
    try {
        const response:any = yield call(apiInstance.get, `reporttool/tools/audit/single-pages-data`);
            
        const data = response?.data;
    
        if (  !data ) {
            throw new Error("Problem fetch website history");
        }
                                     
        yield put(singlePagesDataSuccess(data));

    } catch (error:any) {
        
        // Dispatch error action with the error message
        yield put(singlePagesDataError(error?.response?.data ?? error.toString()));

    }
}

function* singlePageAuditHistory({ payload: { pageId } }:any): SagaIterator {
    try {
        const response:any = yield call(apiInstance.get, `reporttool/tools/audit/single-page-audit/${pageId}`);
            
        const data = response?.data;
    
        if (  !data ) {
            throw new Error("Problem fetch website history");
        }
                                     
        yield put(singlePageAuditSuccessH(data?.mapData));

    } catch (error:any) {
        
        // Dispatch error action with the error message
        yield put(singlePageAuditErrorH(error?.response?.data ?? error.toString()));

    }
}






function* codeSnippetCheckerSaga({ payload} :any): SagaIterator {
    try {
        const response:any = yield call(apiInstance.get, `reporttool/tools/audit/html-snippets-data`);
            
        const data = response?.data;
    
        if (  !data ) {
            throw new Error("Problem fetch code snuppet history");
        }
                                     
        yield put(codeSnippetCheckerSuccess(data));

    } catch (error:any) {
        
        // Dispatch error action with the error message
        yield put(codeSnippetCheckerError(error?.response?.data ?? error.toString()));

    }
}

function* codeSnippetCheckerHistory({ payload: { snippetId } }:any): SagaIterator {
    try {
        const response:any = yield call(apiInstance.get, `reporttool/tools/audit/html-snippet-audit/${snippetId}`);
            
        const data = response?.data;
    
        if (  !data ) {
            throw new Error("Problem fetch html snippet audit history");
        }
                                     
        yield put(codeSnippetCheckerSuccessH(data?.mapData));

    } catch (error:any) {
        console.log(error);
        
        // Dispatch error action with the error message
        yield put(codeSnippetCheckerErrorH(error?.response?.data ?? error.toString()));

    }
}


function* watchTools() : Generator<StrictEffect, void> {
    yield takeLatest(upalodImage.type, UploadImageSaga);
    yield takeLatest(generateDescription.type, generateDescriptionSaga);
    yield takeLatest(checkImageDescription.type, checkImageDescriptionSaga);
    yield takeLatest(getWebsiteContext.type, getWebsiteContextSaga);
    yield takeLatest(auditSinglePage.type, auditSinglePageSaga);
    yield takeLatest(singlePagesDataI.type, singlePagesDataSaga);
    yield takeLatest(singlePageAuditH.type, singlePageAuditHistory);
    yield takeLatest(auditCodeSnippet.type, auditCodeSnippetSaga);
    yield takeLatest(languageLevelChecker.type, languageLevelCheckerSaga);

    yield takeLatest(codeSnippetCheckerI.type, codeSnippetCheckerSaga);
    yield takeLatest(codeSnippetCheckerH.type, codeSnippetCheckerHistory);
}


export { watchTools };
